module.exports = __webpack_public_path__ + "img/37d894fa92af9ee1e970a97e5f7a6054.034bae7b.jpg";